export const getMapFromArrayAndKey = (array, key) =>
  array.reduce((map, item) => {
    if (item?.[key]) {
      map.set(item[key], item);
    }
    return map;
  }, new Map());

export const getMetadataAsMap = (array, key) =>
  array.reduce((map, item) => {
    map.set(item[key], item.requiredMap);
    return map;
  }, new Map());
